import { NotImplementedError } from "../../../../../errors";
import { parseDateFilter } from "../../../../../models/looker/modules/inventory";
import { PromiseHandler } from "../../../../../handlers";
import { FILTER_OPTIONS_PUBLISHER_QUERY } from "../query";
export default class LookerInventoryPublisherFilter extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "looker-inventory-publisher-filter");
    }
    async findItems(filters) {
        const dateFilter = filters.where?.find((filter) => filter.field === "dates");
        if (!dateFilter) {
            throw new Error("Dates filter is required");
        }
        const parsedDateFilter = parseDateFilter(dateFilter);
        const queryBody = {
            ...FILTER_OPTIONS_PUBLISHER_QUERY,
            filters: {
                "billable_agg.filter_date_nyc": parsedDateFilter
            }
        };
        // Add advertiser filter if provided
        const advertiserFilter = filters.where?.find((filter) => filter.field === "advertiserIds");
        if (advertiserFilter) {
            queryBody.filters["conversion_meta_inst.advertiser__id"] = advertiserFilter.value.join(",");
        }
        // Add campaign filter if provided
        const campaignFilter = filters.where?.find((filter) => filter.field === "campaignIds");
        if (campaignFilter) {
            queryBody.filters["conversion_meta_inst.campaign__id"] = campaignFilter.value.join(",");
        }
        const hashKey = await this.sdk.looker.query.hashQuery(queryBody);
        return this.cache.promise(hashKey, () => this.sdk.looker.query
            .run(queryBody)
            .then(({ data, queryMeta }) => [
            {
                data: this.formatPublisherResponse(data),
                queryMeta
            }
        ])
            .catch((e) => {
            console.error(e);
            throw new Error("Failed to fetch inventory dashboard publisher filter options");
        }));
    }
    formatPublisherResponse(data) {
        return data.map((publisher) => ({
            name: publisher["conversion_meta_pub.name"],
            id: publisher["billable_agg.publisher_id"]
        }));
    }
    async saveItem() {
        throw new NotImplementedError("saveItem");
    }
    async deleteItem() {
        throw new NotImplementedError("deleteItem");
    }
}
//# sourceMappingURL=Publisher.js.map